import styled, { css } from "styled-components";

interface SubTabProps {
  $enabled?: string;
}

export const StyledSubTab = styled.div<SubTabProps>`
  .tabbar-container {
    ${(props) =>
      props.$enabled === "enabled" &&
      css`
        svg path {
          stroke: #afb8c1;
        }
      `}

    background-color: #32383F;
    display: flex;
    justify-content: space-between;
    width: calc(100% - 0.8rem);
    height: 3.7rem;
    padding: 0 0.4rem;
    align-items: center;

    .tabbar-group {
      display: flex;
      align-items: flex-start;
      gap: 0.8rem;

      .tabbar-item {
        all: unset;
        display: flex;
        padding: 0.8rem 1.6rem;
        align-items: flex-start;
        gap: 8px;
        border-radius: 0.4rem;
        cursor: pointer;
        color: #afb8c1;

        /* label/label-medium-400 */
        font: var(--label-medium-400);

        &:hover {
          color: #fefefe;
          background-color: var(--hovered);
        }

        &.active {
          color: #fefefe;
          background-color: #6e7781;
          font: var(--label-medium-600);
        }
      }
    }
  }
`;
